import { signal } from '@preact/signals';

import type { HouseholdDeletionState } from '@amumin/api-client';

import { api } from '../api.js';

// 0036: geplande verwijdering van het gezinsbord (DESIGN §8.PR.4). Eén signaal voor de banner in de
// schil en de pagina Jouw gegevens; iedereen in het gezin mag het lezen (de API zegt het).

export type ScheduledDeletion = NonNullable<HouseholdDeletionState['deletion']>;

export const householdDeletion = signal<ScheduledDeletion | null>(null);

/** Leest de stand opnieuw; een fout laat de banner zoals hij was (nooit een rode lap). */
export async function refreshDeletion(): Promise<ScheduledDeletion | null> {
  try {
    const res = await api.privacy.deletion.get();
    householdDeletion.value = res.deletion;
  } catch {
    // stil: de banner is een extra, geen voorwaarde
  }
  return householdDeletion.value;
}
